import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { VerifyEmail } from '@ui/legacy-lib';

@Component({
  selector: 'app-verify-email',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerifyEmailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private store = inject(Store);

  ngOnInit() {
    const token = this.route.snapshot.queryParams.token as string;
    this.store.dispatch(new VerifyEmail(token));
  }
}
